import styled from 'styled-components'

export const TabWrapperStyle = styled.div`
  padding: 9px;
  padding-top: 24px !important;
`
